module.exports = __webpack_public_path__ + "img/B5987E_F8E4DC_6F5939_E9CCBA-256px.316ad2dd.png";